<template>
  <div class="w-full">
    <VuePerfectScrollbar
      class="overflow-scroll"
      style="max-height: calc(-250px + 100vh)"
    >
      <div class="p-6 w-full">
        <div
          v-for="(step, index) in steps"
          :key="index"
          class="w-full"
        >
          <div>
            <span v-html="step.stepLabel"></span>
          </div>
          <div v-if="step.subSteps" class="ml-5">
            <li
              v-for="(subStep, index) in step.subSteps"
              :key="index"
              v-html="subStep.subStepLabel"
              class="w-full"
            ></li>
          </div>
        </div>
      </div>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  name: 'import-mapping-and-analysis',
  props: {
    steps: {
      required: true,
    },
  },

  components: {
    VuePerfectScrollbar,
  },
};
</script>
